import { Component, Input, ChangeDetectionStrategy, booleanAttribute, numberAttribute } from '@angular/core'

@Component({
  selector: 'app-progress-loader',
  standalone: true,
  imports: [],
  templateUrl: './progress-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-loader.component.scss',
})
export class ProgressLoaderComponent {
  @Input({ transform: numberAttribute })
  value: number = 0

  @Input({ transform: booleanAttribute })
  indeterminate: boolean = false

  @Input({ transform: booleanAttribute })
  thin: boolean = false

  @Input({ transform: booleanAttribute })
  loading: boolean = false

  @Input()
  label: string | null = null

  get clampedValue(): number {
    return Math.max(0, Math.min(100, this.value))
  }

  get barWidth(): string | null {
    return this.indeterminate ? null : `${this.clampedValue}%`
  }

  get showShimmer(): boolean {
    return this.loading && !this.indeterminate && this.clampedValue < 100
  }

  get ariaValueNow(): number | null {
    return this.indeterminate ? null : Math.round(this.clampedValue)
  }
}
